import {
  GET_DISCOUNT_TYPES_SUCCESS,
  GET_DISCOUNT_TYPES_FAIL,
  CREATE_DISCOUNT_TYPE_SUCCESS,
  CREATE_DISCOUNT_TYPE_FAIL,
  CLEAR_DISCOUNT_TYPE_ERROR,
} from "./actionTypes"

const INIT_STATE = {
  discountTypes: [],
  loading: false,
  error: null,
  createSuccess: false,
}

const DiscountTypesReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Get all discount types
    case "GET_DISCOUNT_TYPES":
      return {
        ...state,
        loading: true,
        error: null,
      }

    case GET_DISCOUNT_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,
        discountTypes: action.payload || [],
        error: null,
      }

    case GET_DISCOUNT_TYPES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Create discount type
    case "CREATE_DISCOUNT_TYPE":
      return {
        ...state,
        loading: true,
        createSuccess: false,
        error: null,
      }

    case CREATE_DISCOUNT_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        createSuccess: true,
        error: null,
      }

    case CREATE_DISCOUNT_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        createSuccess: false,
        error: action.payload,
      }

    // Clear errors
    case CLEAR_DISCOUNT_TYPE_ERROR:
      return {
        ...state,
        error: null,
      }

    default:
      return state
  }
}

export default DiscountTypesReducer
